import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import Title from '@ckeditor/ckeditor5-heading/src/title';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight.js';
import AutoImage from '@ckeditor/ckeditor5-image/src/autoimage.js';
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import Link from '@ckeditor/ckeditor5-link/src/link';
import ListProperties from '@ckeditor/ckeditor5-list/src/listproperties';
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import Vue from 'vue';

function splitAsDate(dt) {
  // convert from ddmmyyyy to dd-mm-yyyy format
  if (!dt) return false;
  if (dt.length !== 8) return false;
  if (dt) {
    let d = parseInt(dt.substr(0, 2));
    let m = parseInt(dt.substr(2, 2));
    let y = parseInt(dt.substr(4, 4));
    return {
      dd: d,
      mm: m,
      yy: y,
    };
  }
  return false;
}

export default Vue.mixin({
  data: function () {
    return {
      editorConfigBackoffice: {
        // The configuration of the editor.
        plugins: [TodoList, EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin, Heading, MediaEmbed, Indent, IndentBlock, Table, TableToolbar, Title, Highlight, Font,
          ListProperties, Link, AutoLink, BlockQuote, Image, AutoImage],
        toolbar: [
          'heading',
          '|',
          'fontColor',
          'fontBackgroundColor',
          'bold',
          'italic',
          'highlight',
          'link',
          'blockQuote',
          'todoList',
          'bulletedList',
          'numberedList',
          'undo',
          'redo',
          '|',
          'outdent',
          'indent',
          '|',
          'mediaEmbed',
          'insertTable',
        ],
        highlight: {
          options: [
            {
              model: 'greenMarker',
              class: 'marker-green',
              title: 'Green marker',
              color: 'var(--ck-highlight-marker-green)',
              type: 'marker'
            },
            {
              model: 'pinkMarker',
              class: 'marker-pink',
              title: 'Pink marker',
              color: 'var(--ck-highlight-marker-pink)',
              type: 'marker'
            },
            {
              model: 'blueMarker',
              class: 'marker-blue',
              title: 'Blue marker',
              color: 'var(--ck-highlight-marker-blue)',
              type: 'marker'
            },
            {
              model: 'yelloqMarker',
              class: 'marker-yellow',
              title: 'Yellow marker',
              color: 'var(--ck-highlight-marker-yellow)',
              type: 'marker'
            },
          ]
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph', },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1', },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2', },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3', },
          ],
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        title: {
          placeholder: 'Your title goes here'
        },
        placeholder: "Type here.."
      },
      editorConfigAnnouncement: {
        // The configuration of the editor.
        plugins: [TodoList, EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin, Heading, MediaEmbed, Indent, IndentBlock, Table, TableToolbar, Highlight, Font,
          ListProperties, Link, AutoLink, BlockQuote, Image, AutoImage],

        toolbar: [
          'heading',
          '|',
          'fontColor',
          'fontBackgroundColor',
          'bold',
          'italic',
          'highlight',
          'link',
          'blockQuote',
          'todoList',
          'bulletedList',
          'numberedList',
          'undo',
          'redo',
          '|',
          'outdent',
          'indent',
          '|',
          'mediaEmbed',
          'insertTable',
        ],
        highlight: {
          options: [
            {
              model: 'greenMarker',
              class: 'marker-green',
              title: 'Green marker',
              color: 'var(--ck-highlight-marker-green)',
              type: 'marker'
            },
            {
              model: 'pinkMarker',
              class: 'marker-pink',
              title: 'Pink marker',
              color: 'var(--ck-highlight-marker-pink)',
              type: 'marker'
            },
            {
              model: 'blueMarker',
              class: 'marker-blue',
              title: 'Blue marker',
              color: 'var(--ck-highlight-marker-blue)',
              type: 'marker'
            },
            {
              model: 'yelloqMarker',
              class: 'marker-yellow',
              title: 'Yellow marker',
              color: 'var(--ck-highlight-marker-yellow)',
              type: 'marker'
            },
          ]
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph', },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1', },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2', },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3', },
          ],
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
        placeholder: "Type here.."
      },
      validationRules: {
        required(v) {
          if (v) {
            return true;
          }
          return 'This field is required';
        },
        percentageEmployedRule(v) {
          if (!v)
            return 'This field is required';
          if (isNaN(v))
            return 'Provide a numeric value';
          if (v > 100)
            return 'Value should be under 100';
          if (v < 0)
            return 'Value should be over 0';
          return true;
        },
        email(v) {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!v) return true;
          return pattern.test(v) || 'Invalid e-mail format';
        },
        password(v) {
          if (!v) return 'Password is required';
          if (v && v.length < 8) {
            return 'Password should have at least 8 characters';
          }
          return true;
        },
        phone(v) {
          if (!v) return 'field is required';
          if (v && v.length <= 8 && isNaN(v)) {
            return 'Invalid phone number';
          }
          return true;
        },
        date(v) {
          if (v === '') return true;
          let msg = 'Date should be in dd-mm-yyyy format';

          let item = splitAsDate(v);

          if (item === false) return msg;

          if (item.dd < 1 || item.dd > 31) {
            return 'Invalid value for dd in dd-mm-yyyy';
          }
          if (item.mm < 1 || item.mm > 12) {
            return 'Invayarlid value for mm in dd-mm-yyyy';
          }
          let yyyy = (new Date()).getUTCFullYear();
          if (item.yy < yyyy || (item.yy > yyyy + 5)) {
            return 'Invalid value for yyyy in dd-mm-yyyy';
          }
          return true;
        },
        timeoffWorkHours(v) {
          if (!v) return 'field is required';
          if (isNaN(v)) return 'field is required';
          return true;
        },
        timeoffStartOfYear(v) {
          const msg = 'Date should be in dd-mm format';
          if (!v || v.length !== 5) return msg;
          const d = parseInt(v.substr(0, 2));
          const m = parseInt(v.substr(3, 2));
          if (d < 1 || d > 31) return msg;
          if (m < 1 || m > 12) return msg;
          return true;
        },
        timeoffDefaultVacationDays(v) {
          if (!v) return true;
          const msg = 'Please provide valid number of days';
          if (isNaN(v)) return msg;
          const d = parseInt(v);
          if (d <= 0) return msg;
          return true;
        },
      },
      masks: {
        date: '##-##-####',
        salary: '#######.##',
        phone: '####+########',
        timeoffWorkHours: '#.#',
        timeoffStartOfYear: '##-##',
      },
      snackbar: false,
      snackbarMessage: '',
      tokenHeaders: '',
    };
  },
  //#551738
  methods: {
    getColorFromName(input) {
      let stringUniqueHash = [...input].reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
      }, 0);
      return `hsl(${stringUniqueHash % 360}, 95%, 35%)`;
    },
    getNameInitials(fullName) {
      const namesArray = fullName.trim().split(' ');
      let initials = '';
      if (namesArray.length === 1) {
        initials = `${namesArray[0].charAt(0)}`;
      } else {
        initials = `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
      }
      return initials.toUpperCase();
    },
    getIconForDescription(item) {
      return (item.description === 'Birthday') ? 'cake' : (item.description === 'StartDate') ? 'stars' : '';
    },
    datePickerFormat(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    formatToDate(dt) {
      // convert from ddmmyyyy to dd-mm-yyyy format
      if (dt) {
        let item = splitAsDate(dt);
        if (!item) return false;
        let dd = `${item.dd}`;
        let mm = `${item.mm}`;
        return `${dd.padStart(2, '0')}-${mm.padStart(2, '0')}-${item.yy}`;
      }
      return false;
    },
    formatFromDate(item) {
      // convert from UTC(1984-09-04T02:00:00+02:00) date to dd-mm-yyyy format
      if (item) {
        let date = `${item}`.substring(0, 10);
        let [y, m, d] = date.split('-');
        if (m === '01' && d === '01' && y === '0001') {
          return false;
        }
        return `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
      }
      return false;
    },
    // from dd-mm-yyyy format to a date
    formatAsDate(item) {
      if (!item) return false;
      let dt = item.split("-")
      console.log(dt)
      // new Date(year, month, day, hours, minutes, seconds, milliseconds)
      return new Date(parseInt(dt[2]), parseInt(dt[0]), parseInt(dt[1]))
    },
    isDefaultDate(item) {
      if (!item) return true;
      return item.substring(0, 10) === '0001-01-01';
    },
    titleCase(str) {
      str = str.toLowerCase();
      str = str.split(' ');
      for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    }
  },
});
